import { head } from 'lodash-es'

export default {
  computed: {
    /** Error messages */
    addressErrorMessage() {
      return this.$t(`${this.translationTicketErrorPath}.required_address`)
    },
    companyErrorMessage() {
      return this.$t(`${this.translationTicketErrorPath}.required_company`)
    },
    customerNumberErrorMessage() {
      return this.$t(`${this.translationTicketErrorPath}.required_customer_no`)
    },
    locationErrorMessage() {
      return this.$t(`${this.translationTicketErrorPath}.required_ort`)
    },
    zipErrorMessage() {
      return this.getFirstTranslation([
        `${this.translationTicketErrorPath}.required_zip`,
        `form.errors.zip`,
      ])
    },
    invalidDateErrorMessage() {
      return this.$t(`${this.translationTicketTypeErrorPath}._date_invalid`)
    },
    privacyPolicyErrorMessage() {
      return this.$t(`${this.translationTicketTypeErrorPath}._data_protection`)
    },
    numberFormatErrorMessage() {
      return this.$t(`${this.translationTicketTypeErrorPath}._format_error`)
    },
    requiredErrorMessage() {
      return this.getFirstTranslation([
        `${this.translationTicketErrorPath}.required`,
        `${this.translationTicketTypeErrorPath}.required`,
        `form.errors.required`,
      ])
    },
    invalidItemNumberErrorMessage() {
      return this.$t(`${this.translationTicketTypeErrorPath}.required_item_number`)
    },
    chooseErrorMessage() {
      return this.getFirstTranslation([
        `${this.translationTicketTypeErrorPath}.required_choose`,
        `${this.translationTicketPath}.engine.error.required_choose`,
      ])
    },
    firstNameErrorMessage() {
      return this.getFirstTranslation([
        `${this.translationTicketErrorPath}.required_name`,
        `${this.translationTicketTypeErrorPath}.requiredname_firstname`,
      ])
    },
    lastNameErrorMessage() {
      return this.getFirstTranslation([
        `${this.translationTicketErrorPath}.required_surname`,
        `${this.translationTicketTypeErrorPath}.requiredname_last_name`,
      ])
    },
    fullNameErrorMessage() {
      return this.getFirstTranslation([
        `${this.translationTicketTypeErrorPath}.requiredname`,
        `${this.translationTicketTypeErrorPath}.required_name`,
      ])
    },
    numbersErrorMessage() {
      return this.getFirstTranslation([
        `${this.translationTicketTypeErrorPath}.requirednumbers`,
        `${this.translationTicketTypeErrorPath}.required_numbers`,
      ])
    },
    numbersAndHyphensErrorMessage() {
      return this.$t(`${this.translationTicketTypeErrorPath}.required_item_number`)
    },
    fileErrorMessage() {
      return this.getFirstTranslation([
        `${this.translationTicketTypeErrorPath}.requiredupload`,
        `${this.translationTicketTypeErrorPath}.required_upload`,
        `${this.translationTicketPath}.battery.error.requiredupload`,
      ])
    },
    termsErrorMessage() {
      return this.$t(`${this.translationTicketTypeErrorPath}.terms`)
    },
    fileUploadErrorMessage() {
      return this.$t(`${this.translationTicketTypeErrorPath}._fileupload`)
    },
    workTimeErrorMessage() {
      return this.$t(`${this.translationTicketTypeErrorPath}.required._worktime`)
    },
    invalidAnErrorMessage() {
      return this.$t(`${this.translationTicketTypeErrorPath}.wrong_an`)
    },
    invalidSnErrorMessage() {
      return this.$t(`${this.translationTicketTypeErrorPath}.wrong_sn`)
    },
    invalidSn2ErrorMessage() {
      return this.$t(`${this.translationTicketTypeErrorPath}.wrong_sn2`)
    },
    emailErrorMessage() {
      return this.$t('form.error.email')
    },
    phoneErrorMessage() {
      return this.$t('form.error.phone')
    },
  },
  methods: {
    getFirstTranslation(keys = []) {
      let translation = head(keys) || ''
      keys.find(key => {
        const translatedKey = this.$t(key)

        if (translatedKey !== key) {
          translation = translatedKey

          return true
        }
        return false
      })

      return translation
    },
  },
}
